import { Component, computed, inject, input } from "@angular/core";
import { QueriedDataEntity } from "@lib/core/modules/graphql/graphql.types";
import { ComponentWithModelInput } from "@lib/core/types/component.types";
import { map, of, Subject } from "rxjs";
import { UserRolesService } from "@lib/core/services/user-roles.service";
import { AsyncPipe } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { MatIconButton } from "@angular/material/button";
import { DialogService } from "@lib/base/services/dialog.service";
import { CloseAlertDialogComponent } from "@workspace/pages/alerts/close-alert-dialog/close-alert-dialog.component";
import { Alerte } from "@graphql-generated/graphql";
import {
    closeAlertDialogFormDefinition,
} from "@workspace/pages/alerts/close-alert-dialog/close-alert-dialog-form-definition";

export const closingAlertDialogClosed = new Subject<void>();

@Component({
    selector: "app-close-alert-button",
    imports: [
        AsyncPipe,
        MatIcon,
        MatIconButton,
    ],
    templateUrl: "./close-alert-button.component.html",
    styleUrl: "./close-alert-button.component.scss",
})
export class CloseAlertButtonComponent implements ComponentWithModelInput {
    private roleService = inject(UserRolesService);
    private dialogService = inject(DialogService);

    modelInput = input<QueriedDataEntity>();

    caCloseAlert = computed(() => {
        const model = this.modelInput();
        if (model == null
            || model.__typename !== "Alerte"
            || (model as Alerte).closingDate != null) {
            return of(false);
        }
        return this.roleService.getAuthorizedActions(model.__typename).pipe(
            map(operation => operation.includes("UPDATE")),
        );
    });

    closeAlert() {
        const alert = this.modelInput() as Alerte;

        const dialogRef = this.dialogService.open(CloseAlertDialogComponent, {
            data: {
                model: alert,
                form: closeAlertDialogFormDefinition,
            },
        });

        dialogRef.afterClosed().subscribe(_ => closingAlertDialogClosed.next());
    }
}
